module.exports = __webpack_public_path__ + "static/img/icon-2.0b47a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/icon-2.png
// module id = v5Ua
// module chunks = 0